'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./list.scss');

var _withTypography = require('../with-typography');

var _withTypography2 = _interopRequireDefault(_withTypography);

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function List(_ref) {
  var size = _ref.size,
      ordered = _ref.ordered,
      orientation = _ref.orientation,
      children = _ref.children,
      className = _ref.className,
      type = _ref.type,
      showFirstIcon = _ref.showFirstIcon,
      props = _objectWithoutProperties(_ref, ['size', 'ordered', 'orientation', 'children', 'className', 'type', 'showFirstIcon']);

  var classes = (0, _classnames2.default)('list', 'list--size-' + size, 'list--orientation-' + orientation, type && 'list--type-' + type, ordered && 'list--ordered', showFirstIcon && 'list--show-first-icon', className);

  return ordered ? _react2.default.createElement(
    'ol',
    _extends({ className: classes }, props),
    children
  ) : _react2.default.createElement(
    'ul',
    _extends({ className: classes }, props),
    children
  );
}

List.propTypes = {
  size: _propTypes2.default.string,
  ordered: _propTypes2.default.bool,
  orientation: _propTypes2.default.string,
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  showFirstIcon: _propTypes2.default.bool, // only valid for horizontal lists
  type: _propTypes2.default.oneOf(['success', 'error', 'warning', 'info'])
};

List.defaultProps = {
  size: 'medium',
  orientation: 'vertical',
  ordered: false,
  showFirstIcon: false
};

exports.default = (0, _withTypography2.default)(List, { color: 'dark' });